import React from 'react'
import { Form, Icon, Input, Button, Row, Col } from 'antd';
import eventTypes from './eventTypes';

export const ValidationFormStep3 = (props) => {
    if (props.currentStep !== 'Step 3') {
      return null
    }
    return(
      <div className="form-group">


            <h3 style={{ display: 'inline-block !important' }}>Confirmation - SAE has been recorded!</h3>

            <h4 style={{ display: 'inline-block !important' }}>Site ID: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.siteID}</span></h4>
            <h4 style={{  display: 'inline-block !important' }}>User ID: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.userID}</span></h4>
            <h4 style={{  display: 'inline-block !important' }}>Subject ID: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.subjectID}</span></h4>

            <div className="validation-exists">
                <h3 style={{  display: 'inline-block !important' }}>SAE Information</h3>

                <h4 style={{  display: 'inline-block !important' }}>SAE Occurred: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>
                    {props.validationExistsSAEOccurred === true ? <div>Yes</div> : <div>No</div> }
                </span></h4>

              {props.validationExistsSAEOccurred && (<div>
                {props.validationExistsSAEType && (<h4 style={{  display: 'inline-block !important' }}>SAE event type: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>
                    {eventTypes[props.validationExistsSAEType]}
                </span></h4>)}

                {props.validationExistsSAEOccurred ?
                    <div>
                        <h4 style={{ marginTop: '2rem', display: 'inline-block !important' }}>SAE Date: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.validationExistsSAEDate}</span></h4>
                        <h4 style={{ marginTop: '2rem', display: 'inline-block !important' }}>SAE Comments: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.validationExistsSAEComments}</span></h4>
                    </div>
                    :
                    <div>&nbsp;</div>
                }
                </div>)}
            </div>

      </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/SaeRecording/Step3.js